import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { Slider } from '@mui/material';
import { bgMapObject } from '../map/layers';

const boundaryMapStyleObject = {
	basic: 'flow_sido_boundary_black',
	white: 'flow_sido_boundary_black',
	midNight: 'flow_sido_boundary_white',
	satellite: 'flow_sido_boundary_white',
};

export default function InoutflowLegend(props) {
	const { step } = useContext(AppContext);

	const handleMapOptionLegend = (e) => {
		const value = e.target.value;

		if (value === 'emd') {
			props.flowLayers.bgEmdLayer.setVisible(e.target.checked);
			return;
		}

		if (value === 'sgg') {
			props.flowLayers.bgSggLayer.setVisible(e.target.checked);
			return;
		}

		if (value === 'sido') {
			props.flowLayers.bgSidoLayer.setVisible(e.target.checked);
			return;
		}

		if (value === `${props.target.flowHub}`) {
			props.flowLayers.centralHubT.setVisible(e.target.checked);
			props.flowLayers.centralHubV.setVisible(e.target.checked);
			return;
		}

		if (value === 'collapseBgMap') {
			props.setCollapseBgMap(e.target.checked);
		}
	};

	const handleHubGridOpacity = (e, newValue) => {
		if (typeof newValue === 'number') {
			props.setHubGridOpacity(newValue);
			props.flowLayers.centralHubT.setOpacity(newValue);
			props.flowLayers.centralHubV.setOpacity(newValue);
		}
	};

	const handleBgMap = (e) => {
		const value = e.target.value;
		props.setFlowBgMap(value);
		Object.values(bgMapObject).forEach((name) => props.bgLayers[name].setVisible(!e.target.checked));

		['bgSidoLayer', 'bgSggLayer', 'bgEmdLayer'].forEach((target) =>
			props.flowLayers[target].getSource().updateParams({
				styles: boundaryMapStyleObject[value],
			})
		);

		if (value !== 'none') {
			props.bgLayers[bgMapObject[value]].setVisible(e.target.checked);
		}
	};

	return (
		<div>
			{step === props.step && props.legendControlOpen ? (
				<div className={`mapSelectWrap mapOptionLegend ${props.target.cssName}`}>
					<span className="legendCloseBtn" onClick={() => props.setLegendControlOpen(false)}>
						&times;
					</span>
					<div className="regionChecked">
						<label>
							<input
								type="checkbox"
								name=""
								id=""
								value={`${props.target.flowHub}`}
								onChange={handleMapOptionLegend}
								defaultChecked
							/>
							{props.target.name} 중심 거점
							<span className={`LegendColorBox ${props.target.color}`}></span>
						</label>
						<div className="depth">
							<label>
								불투명도
								<Slider
									value={props.hubGridOpacity}
									min={0}
									max={1}
									step={0.1}
									onChange={handleHubGridOpacity}
									valueLabelDisplay="auto"
								/>
							</label>
						</div>
						<label>
							<input type="checkbox" name="" id="" value="emd" onChange={handleMapOptionLegend} />
							읍면동(행정동) 경계
						</label>
						<label>
							<input type="checkbox" name="" id="" value="sgg" onChange={handleMapOptionLegend} defaultChecked />
							시군구 경계
						</label>
						<label>
							<input type="checkbox" name="" id="" value="sido" onChange={handleMapOptionLegend} />
							시도 경계
						</label>
						<label>
							<input
								type="checkbox"
								name=""
								id=""
								value="collapseBgMap"
								defaultChecked
								onChange={handleMapOptionLegend}
							/>
							배경지도
						</label>
						{props.collapseBgMap ? (
							<div className="depth">
								<label>
									<input
										type="radio"
										name=""
										id=""
										value="midNight"
										checked={props.flowBgMap === 'midNight'}
										onChange={handleBgMap}
									/>
									다크
								</label>
								<input
									type="radio"
									name=""
									id="basic"
									value="basic"
									checked={props.flowBgMap === 'basic'}
									onChange={handleBgMap}
								/>
								<label htmlFor="basic">기본</label>
								<input
									type="radio"
									name=""
									id="white"
									value="white"
									checked={props.flowBgMap === 'white'}
									onChange={handleBgMap}
								/>
								<label htmlFor="white">백지도</label>
								<label>
									<input
										type="radio"
										name=""
										id=""
										value="satellite"
										checked={props.flowBgMap === 'satellite'}
										onChange={handleBgMap}
									/>
									위성
								</label>
								<label>
									<input
										type="radio"
										name=""
										id=""
										value="none"
										checked={props.flowBgMap === 'none'}
										onChange={handleBgMap}
									/>
									배경 지도 끄기
								</label>
							</div>
						) : null}
					</div>
				</div>
			) : step === props.step && !props.legendControlOpen ? (
				<div className={`mapOptionLegendIcon ${props.target.cssName}`} onClick={() => props.setLegendControlOpen(true)}>
					<img src="img/mapLayerIcon.png" alt="레이어옵션" />
				</div>
			) : null}
		</div>
	);
}
